import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'
export const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        show: false,
        message: '',
        type: '',
    },
    reducers: {
        SHOW_NOTIFICATION: (
            state,
            action: PayloadAction<{
                message: string
                type: 'error' | 'success'
            }>
        ): void => {
            state.show = true
            state.message = action.payload.message
            state.type = action.payload.type
        },
        CLOSE_NOTIFICATION: (state): void => {
            state.show = false
            state.message = ''
            state.type = ''
        },
    },
})

export const { SHOW_NOTIFICATION, CLOSE_NOTIFICATION } =
    notificationSlice.actions

export const selectNotification = (state: RootState) => state.showNotification

export default notificationSlice.reducer
